import {AxiosInstance, AxiosResponse} from "axios";

export enum TrackerType {
    ATTACHMENT_READ = "attachment-read",
    ATTACHMENT_DOWNLOAD = "attachment-download",
}

/**
 * The tracker resource.
 *
 * @param {Object} client - The injected client.
 * @returns {Object} The public object.
 */
export default function (client: AxiosInstance) {
    return {
        async track(type: TrackerType, trackableId: number, trackableType: string): Promise<any> {
            const data = {
                trackable_id: trackableId,
                trackable_type: trackableType,
                type
            };

            return client.post('track', {data})
                .then((response: AxiosResponse) => response.data)
                .catch((_error: AxiosResponse) => {});
        }
    };
}
